import { FC } from "react";
import classNames from "classnames";

import { SourceTable } from "../SourceTable";
import { OverviewSourceUsageProps } from "./types";
import OverviewSourceUsageChart from "./OverviewSourceUsageChart/OverviewSourceUsageChart";
import OverviewSourceUsageSkeleton from "./OverviewSourceUsageSkeleton/OverviewSourceUsageSkeleton";

import styles from "./OverviewSourceUsage.module.css";



const OverviewSourceUsage: FC<OverviewSourceUsageProps> = ({
  className,
  rows,
  isLoading,
  chartData,
  chartSeries,
}) => {
  if (isLoading) {
    return (
      <div className={classNames(styles["overview_source_usage"], className)}>
        <OverviewSourceUsageSkeleton />
      </div>
    );
  }

  return (
    <div className={classNames(styles["overview_source_usage"], className)}>
      <OverviewSourceUsageChart
        data={chartData}
        series={chartSeries}
        hideMoreSourcesLegend={chartData !== undefined && chartSeries !== undefined}
      />
      <SourceTable rows={rows} />
    </div>
  );
};

export default OverviewSourceUsage;
